import { useState, useEffect } from 'react';
import { getSitesByClientId } from 'services/clients/sites/siteDetails';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { showError } from '../../../../../redux/common/actions';
import { SHOW_ALL_OPTION } from '../../constants';

export const useSites = (clientId, showAll = true) => {
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [sites, setSites] = useState([]);

	useEffect(() => {
		const loadSites = async () => {
			try {
				const response = await getSitesByClientId(clientId);
				if (response?.status) {
					const data = response.data || [];

					// Flatten regions/sites structure if response contains regions
					let fetchedSites = [];
					if (Array.isArray(data)) {
						// Check if data has nested structure with regions
						data.forEach(item => {
							if (item.sites && Array.isArray(item.sites)) {
								// Flatten: extract sites from each region
								fetchedSites = [...fetchedSites, ...item.sites];
							} else {
								// Assume flat structure
								fetchedSites.push(item);
							}
						});
					}

					// Only add 'Show All' if there are actual sites and showAll is true
					const updatedSites = (showAll && fetchedSites.length > 0)
						? [SHOW_ALL_OPTION, ...fetchedSites]
						: fetchedSites;
					setSites(updatedSites);
				}
			} catch (error) {
				dispatch(showError(t('message.failedToLoadSites')));
			}
		};
		if (clientId) {
			loadSites();
		}
	}, [clientId, showAll, dispatch, t]);

	return sites;
};
